import { tz } from 'moment-timezone';

const invalidTimeZones = [
  'CST6CDT',
  'EST5EDT',
  'GMT+0',
  'GMT-0',
  'GMT0',
  'MST7MDT',
  'PST8PDT',
  'Pacific/Kanton',
  'Etc/',
];

const getTimeZonesArray = () =>
  tz
    .names()
    ?.filter(
      (timezone) =>
        !invalidTimeZones.includes(timezone) && !timezone.startsWith('Etc/'),
    );
export default getTimeZonesArray;
